import packageInfo from '../package.json';

export const ApiPaths = {
    Url: process.env.REACT_APP_API_URL,
};

export const CaptchaInfo = {
    SiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

// App Insights (browser) — replaces Sentry. Ingestion connection string is safe to ship
// in the bundle (ingestion-only, like the old Sentry DSN).
//
// Resolved at RUNTIME from window.__APPCONFIG__ (public/config.js, written per-environment
// by the release pipeline) so a single build artifact reports to the correct per-env
// workspace and prod telemetry stays isolated. Falls back to the build-time env var when
// the runtime value is absent (local dev, or before the per-env pipeline var is set).
const runtimeConfig = (typeof window !== 'undefined' && window.__APPCONFIG__) || {};

export const TelemetryInfo = {
    ConnectionString:
        runtimeConfig.appInsightsConnectionString || process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
};

export const BuildInfo = {
    IsPortal: process.env.REACT_APP_BUILD_TARGET === '' || process.env.REACT_APP_BUILD_TARGET === 'portal',
    IsBedBoard: process.env.REACT_APP_BUILD_TARGET === 'bedboard',
};

export const VersionInfo = {
    AppName: process.env.REACT_APP_NAME,
    AppVersion: process.env.REACT_APP_VERSION,
    PostAcuteClientVersion: packageInfo.dependencies['@medone/medonehp-api-client'],
    BedBoardClientVersion: packageInfo.dependencies['@medone/medonehp-bedboard-client'],
};

// CHPL certification identity (listing 11426). A committed constant — not an env var — so the dashboard shows the
// same product name and version on local, QA and Staging (AC4). AppVersion above stays env-derived for telemetry.
export const ProductInfo = {
    Name: 'Memry',
    Version: '0',
};

export const getPaginationConfig = (data) => {
    return {
        total: (data || []).length,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
    };
};

export const SignalRDefaultDebounceTimeout = 1000;
export const SignalRDefaultDebounceOptions = { maxWait: 2000 };
